import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { createProblemComment, createReport, deleteProblemComment, listProblemComments } from '../services/contentService';
import { ensureUserProfile } from '../services/profileService';

function ProblemComments({ problem }) {
  const { currentUser } = useAuth();
  const [comments, setComments] = useState([]);
  const [text, setText] = useState('');
  const [anonymous, setAnonymous] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const loadComments = useCallback(async () => {
    if (!problem?.id) return;
    setError('');
    try {
      setComments(await listProblemComments(problem.id));
    } catch (err) {
      setError(err.message);
    }
  }, [problem]);

  useEffect(() => {
    loadComments();
  }, [loadComments]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setMessage('');
    try {
      if (!text.trim()) return;
      const profile = await ensureUserProfile(currentUser);
      await createProblemComment(problem, profile, text, anonymous);
      setText('');
      await loadComments();
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleDelete(commentId) {
    setError('');
    setMessage('');
    try {
      await deleteProblemComment(problem.id, commentId);
      await loadComments();
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleReport(comment) {
    setError('');
    setMessage('');
    try {
      await createReport(currentUser.uid, 'problemComment', `${problem.id}/${comment.id}`, 'Harmful, unsafe, or inappropriate comment');
      setMessage('Comment reported.');
    } catch (err) {
      setError(err.message);
    }
  }

  if (problem.visibility === 'private') {
    return null;
  }

  return (
    <div className="page-comments">
      <p className="tag">Discussion</p>
      {error ? <p className="error-text">{error}</p> : null}
      {message ? <p className="notice">{message}</p> : null}
      {comments.map((comment) => (
        <article className="page-comment" key={comment.id}>
          <strong>{comment.authorName}</strong>
          <p>{comment.text}</p>
          <div className="button-row compact-row comment-actions">
            {currentUser?.uid === comment.authorId || currentUser?.uid === problem.ownerId ? (
              <button className="button button-secondary button-small" type="button" onClick={() => handleDelete(comment.id)}>Delete</button>
            ) : null}
            {currentUser && currentUser.uid !== comment.authorId ? (
              <button className="button button-secondary button-small" type="button" onClick={() => handleReport(comment)}>Report</button>
            ) : null}
          </div>
        </article>
      ))}
      {currentUser ? (
        <form className="comment-form problem-comment-form" onSubmit={handleSubmit}>
          <input value={text} onChange={(event) => setText(event.target.value)} placeholder="Join the discussion" />
          <label className="checkbox-label"><input type="checkbox" checked={anonymous} onChange={(event) => setAnonymous(event.target.checked)} /> Anonymous</label>
          <button className="button button-secondary button-small" type="submit">Post</button>
        </form>
      ) : <p className="muted">Log in to discuss.</p>}
    </div>
  );
}

export default ProblemComments;
